module.exports = __webpack_public_path__ + "static/media/Loudred_gaussian2.96115270.png";